import React from "react";
import { CtaLink } from "../../Elements";
import { CTAButtonWrapper } from "./style";

const CTAButton = ({ link, target, type, label }) => {
	return (
		<CTAButtonWrapper>
			<CtaLink
				className="cta-button"
				type={type}
				value={link}
				target={target}
				convertToButton={true}
			>
				{label}
			</CtaLink>
		</CTAButtonWrapper>
	);
};

export default CTAButton;
